<template>
  <div class="deliveryTable">
    <h2 class="deliveryTable__title">{{ data.Title }}</h2>
    <template v-for="(table, index) in tables">
      <SimpleTable
        :data="table"
        :key="index"
        class="deliveryTable__table"
        :variants="['borderless', 'firstColumnFixed']"
      />
    </template>
  </div>
</template>

<script>
import SimpleTable from '@/components/SimpleTable';
export default {
  name: 'DeliveryTable',
  components: { SimpleTable },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      tables: [],
    };
  },
  mounted() {
    if (this.data.TableHeadings && this.data.DeliveryMethods) {
      this.tables = this.data.DeliveryMethods.map(method => ({
        headings: [method.Title, ...this.data.TableHeadings.map(heading => heading.Heading)],
        content: method.Content.map(content => content.map(item => item.ColumnContent)),
      }));
    }
  },
};
</script>

<style scoped lang="scss">
.deliveryTable {
  padding: 3rem;
  background-color: $cWhite;

  @include rwd('large-phone') {
    padding: 2rem;
  }

  &__title {
    margin-bottom: 3rem;
    font-size: 3.6rem;
    font-weight: 60;
    line-height: 4.5rem;
    color: $cMainDark;

    @include rwd('laptop') {
      margin-bottom: 2rem;
      font-size: 3rem;
      line-height: 3.8rem;
    }

    @include rwd('large-phone') {
      font-size: 2.4rem;
      line-height: 3.2rem;
    }
  }

  &__table {
    margin-bottom: 3.5rem;

    &:last-of-type {
      margin-bottom: 0;
    }

    @include rwd('tablet') {
      margin-bottom: 0;
    }
  }
}
</style>
